'use client';
import SmallArrowDown from '@/app/_components/ui/icons/SmallArrowDown.svg';
import CommentForm from './CommentForm';
import { useState, useEffect } from 'react';
import { useSession } from 'next-auth/react';
import SortComments from './SortComments';
import Indices from './Indices';
import Comment from './Comment';
import CommentsWithImage from './CommentsWithImage';
import AverageRating from '../../share/AverageRating';
import { useProductComments } from '@/app/_hooks/useComment';
import AjaxPagination from '../../share/AjaxPagination';
import { useRouter } from 'next/navigation';
import ArrowTop from '@/app/_components/ui/icons/ArrowTop.svg';
import CommentsImageModal from './CommentsImageModal';
import { usePathname } from 'next/navigation';

export default function Comments({ productId, indices, comments }) {
  const [commentsList, setCommentsList] = useState(comments);
  const [openCommentModal, setOpenCommentModall] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [currentSort, setCurrentSort] = useState('');
  const { productCommentsInfo } = useProductComments(
    productId,
    currentSort,
    pageNumber
  );
  const [commentsModal, setCommentsModal] = useState(false);
  const [selectedComment, setSelectedComment] = useState(null);
  const [firstInit, setFirstInit] = useState(true);
  const [closeSection, setCloseSection] = useState(false);
  const { data: session } = useSession();
  const isUser = !!session?.user;
  const pathname = usePathname();
  const router = useRouter();

  const openCommentsWithImage = (id) => {
    setSelectedComment(id);
    setCommentsModal(true);
  };

  useEffect(() => {
    if (!firstInit && productCommentsInfo && productCommentsInfo.data) {
      setCommentsList(productCommentsInfo.data);
    }
  }, [productCommentsInfo.data]);
  const addCommentHandler = async (values) => {
    setOpenCommentModall(false);
  };
  const closeCommentModal = () => {
    setOpenCommentModall(false);
  };
  const checkOpenCommentModal = () => {
    if (!isUser) {
      router.push(`/users/login?callbackUrl=${encodeURIComponent(pathname)}`);
    } else {
      setOpenCommentModall(true);
    }
  };
  const loadingMore = () => {
    setCommentsList(productCommentsInfo.data);
    setFirstInit(false);
  };
  const changePagination = (page) => {
    setPageNumber(page);
    // Scroll to the spComments section
    const spCommentsSection = document.getElementById('spComments');
    if (spCommentsSection) {
      spCommentsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const handlerSort = (value) => {
    setFirstInit(false);
    setCurrentSort(value);
  };

  return (
    <>
      <div
        className="spComments  md:mt-8 mt-3 p-0 md:p-8 bg-white"
        id="spComments"
      >
        <div className="flex md:pb-10 md:pt-0 p-4 justify-between border-b border-light-gray-300 md:border-none">
          <h2 className="spNavTitle text-sm md:text-base text-gray-500 font-bold ">
            دیدگاه کاربران
          </h2>
          <div
            className="md:hidden"
            onClick={() => setCloseSection((prev) => !prev)}
          >
            <ArrowTop className={`${closeSection && 'rotate-180'}`} />
          </div>
        </div>

        <div
          className={`${
            closeSection
              ? 'mt-0 p-0 h-0 overflow-hidden '
              : 'p-2 md:p-0 mt-4 md:mt-0 '
          }`}
        >
          <div className="max-w-[1074px] mx-auto">
            <div className="commentsTopSection md:flex justify-between">
              <div className="flex-1 flex border border-light-gray-300 md:border-none rounded-md p-3.5 mb-5">
                <div
                  className="max-w-[305px] pl-5 cursor-pointer"
                  onClick={checkOpenCommentModal}
                >
                  <div className="md:flex items-center">
                    <div className="font-bold text-xl text-black">
                      {!indices?.total || indices?.total == 0
                        ? 'بدون امتیاز'
                        : `${indices?.score} از 5`}
                    </div>
                    <div className="md:text-sm text-xs text-gray-600 pr-2 mt-3.5 md:mt-0">
                      از مجموع {productCommentsInfo?.total} دیدگاه
                    </div>
                  </div>
                  <div className="flex md:mt-7 mt-4">
                    <AverageRating score={indices?.score || 0} />
                  </div>
                </div>
                <div className="flex-1 justify-center">
                  <div>
                    <Indices indices={indices} />
                  </div>
                </div>
              </div>

              <div className="md:max-w-[305px] pt-5 pb-5 md:mb-0 md:pt-0  border-t border-b border-light-gray-300 md:border-none border-light-gray-300">
                <div className="md:text-center">
                  <div className="text-sm md:text-xl text-black font-bold pb-3 b">
                    دیدگاه خود را با ما در میان بگذارید
                  </div>
                  <div className="text-sm hidden md:block text-black font-light">
                    با ارسال دیدگاه خود می‌توانید به دیگران کمک کنید تا خریدی
                    مطمئن داشته باشند.
                  </div>
                  <button
                    className="text-color-primary hover:bg-color-primary transition hover:text-white  border border-color-primary w-full py-2.5 flex justify-center font-bold md:py-3 rounded-md mt-1.5 md:mt-5"
                    onClick={checkOpenCommentModal}
                  >
                    ثبت دیدگاه
                  </button>
                </div>
              </div>
            </div>
            <CommentsWithImage
              id={productId}
              openCommentsWithImage={openCommentsWithImage}
            />
            {commentsModal && (
              <CommentsImageModal
                productId={productId}
                selectedComment={selectedComment}
                openModal={commentsModal}
                onClose={() => setCommentsModal(false)}
              />
            )}
            {comments?.length > 0 && (
              <div className="commentMainSection mt-3 md:mt-14">
                <div className="commentSort flex md:justify-start justify-between items-center md:pb-4 md:border-b border-light-gray-300">
                  <div className=" text-xs md:text-sm font-bold text-gray-500 ">
                    <span className="ml-1">{productCommentsInfo?.total}</span>
                    دیدگاه ثبت شده است
                  </div>
                  <div className="h-[15px] md:border-l border-light-gray-300  pr-5"></div>
                  <SortComments handlerSort={handlerSort} sort={currentSort} />
                </div>
                {commentsList.map((comment, index) => (
                  <div key={index}>
                    <Comment
                      comment={comment}
                      key={index}
                      openCommentsWithImage={openCommentsWithImage}
                    />
                    {comment.replies.length > 0 &&
                      comment.replies.map((reply, index) => (
                        <div className="pr-14" key={index}>
                          <Comment
                            comment={reply}
                            reply={true}
                            key={index}
                            openCommentsWithImage={openCommentsWithImage}
                          />
                        </div>
                      ))}
                  </div>
                ))}
              </div>
            )}
            {productCommentsInfo?.total > 5 && (
              <>
                {commentsList.length == 5 && pageNumber == 1 ? (
                  <div
                    className="text-xs text-ocean-blue mt-4 flex cursor-pointer"
                    onClick={loadingMore}
                  >
                    نمایش بیشتر
                    <SmallArrowDown fill="#2A75BB" />
                  </div>
                ) : (
                  <>
                    <AjaxPagination
                      itemsPerPage={20}
                      totalItems={productCommentsInfo.total}
                      currentPage={parseInt(pageNumber)}
                      changePagination={(page) => changePagination(page)}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <CommentForm
          openModal={openCommentModal}
          onClose={closeCommentModal}
          onSubmit={addCommentHandler}
          productId={productId}
        />
      </div>
    </>
  );
}
